let apiBase = '';
let appVersion = 'dev';
let beaconKey = '';

export function setApiBase(base: string) {
  apiBase = base;
}

export function getApiBase(): string {
  return apiBase;
}

/** Release version of the client bundle (set by the host app from its build).
 *  Sent with each /api/verify so the worker can stamp it onto the audit. */
export function setAppVersion(version: string) {
  if (version) appVersion = version;
}

export function getAppVersion(): string {
  return appVersion;
}

/** Base64 AES key used to seal telemetry payloads (set by the host app from its
 *  build env). Empty string means "use the built-in TELEMETRY_KEY" — see crypto.ts. */
export function setBeaconKey(key: string) {
  if (key) beaconKey = key;
}

export function getBeaconKey(): string {
  return beaconKey;
}

// 只有带 ?dbg 时才记录 —— 与 DebugOverlay 的挂载条件一致。生产访客(无 ?dbg)下
// slDbg 退化成一次布尔判断,不在点击→跳转热路径上做无谓的字符串拼接/数组 push。
const DBG = typeof window !== 'undefined' && /[?&]dbg\b/.test(window.location.search);

/**
 * 调试日志(仅真实落地页的 ?dbg 浮层用):把关键链路步骤写进 window.__SLDBG,
 * DebugOverlay 定时读出显示。
 */
export function slDbg(msg: string): void {
  if (!DBG) return;
  const w = window as unknown as { __SLDBG?: string[] };
  if (!w.__SLDBG) w.__SLDBG = [];
  w.__SLDBG.push(`+${Math.round(performance.now())}ms ${msg}`);
}
